import React, { useState, useEffect, useRef } from 'react'
import { categoryInfo } from '../../utils/paymentoptions'
import styled from 'styled-components'
import { BottomSection } from './BottomSection'
import { PaymentCategoryDropdown } from './PaymentCategoryDropdown'
import { ConferenceDropdown } from './ConferenceDropdown'
import { PaymentMethodButtons } from './PaymentMethodButtons'

const PaymentContainer = () => {
    const [selectedCategory, setSelectedCategory] = useState(null);
    const [selectedConference, setSelectedConference] = useState(null);
    const [isPaymentCategoryOpen, setIsPaymentCategoryOpen] = useState(false);
    const [isConferenceOpen, setIsConferenceOpen] = useState(false);
    const [selectedPaymentMethod, setSelectedPaymentMethod] = useState(null);

    const handleCategorySelect = (category) => {
        setSelectedCategory(category);
        setIsPaymentCategoryOpen(false);
        setSelectedConference(null);
    };

    const handleConferenceSelect = (conference) => {
        setSelectedConference(conference.name);
        setIsConferenceOpen(false);
    };

    const handleSubmit = () => {
        if (selectedCategory?.hasOptions && selectedConference) {
            const selectedOption = selectedCategory.options.find(
                option => option.name === selectedConference
            );
            
            if (selectedOption && selectedOption.link) {
                window.location.replace(selectedOption.link);
            }
        } else if (selectedCategory?.typeId === 1) {
            window.location.replace('https://paystack.com/pay/amrsghana_donations');
        } else {
            alert('Please select a valid option before submitting');
        }
    };

    return (
        <Container>
            <div className='payment-section-container'>
                <h4 className='container-header'>
                    Please select your payment category and method
                </h4>
                
                <PaymentCategoryDropdown
                    categoryInfo={categoryInfo}
                    selectedCategory={selectedCategory}
                    isOpen={isPaymentCategoryOpen}
                    onToggleOpen={setIsPaymentCategoryOpen}
                    onSelect={handleCategorySelect}
                />

                {selectedCategory?.hasOptions && (
                    <ConferenceDropdown
                        selectedCategory={selectedCategory}
                        selectedConference={selectedConference}
                        isOpen={isConferenceOpen}
                        onToggleOpen={setIsConferenceOpen}
                        onSelect={handleConferenceSelect}
                    />
                )}
                
                <PaymentMethodButtons 
                    selectedMethod={selectedPaymentMethod}
                    onMethodSelect={setSelectedPaymentMethod}
                />

                <div className="submit-info">
                    <button 
                        className="submit-button" 
                        onClick={handleSubmit}
                    >
                        Make Payment
                    </button>
                </div>
            </div>

            <BottomSection />
        </Container>
    )
}


const Container = styled.div`
    .payment-section-container {
        width: 70%;
        margin: 4em auto 15em auto;
        height: 25vh;

        .container-header{
            font-size: 1.1em;
        }

        h6 {    
            color: #777777;
            font-size: 0.8em;
            margin-bottom: 0.5em;
        }

        .submit-info {
            height: 3.2em;
            margin-top: 3em;
            display: flex;
            justify-content: center;
            align-items: center;

            button {
                width: 35%;
                height: 100%;
                background-color: #CA9D3B;
                color: white;
                font-size: auto;
                font-weight: 600;
                border: none;
                border-radius: 1.5em;
                cursor: pointer;
            }
        }
    }

    @media only screen and (min-width: 750px) {
        .payment-section-container {
            width: 30rem;
        }
    }
`

export default PaymentContainer;